import _ from "lodash";
import abtest from 'common/abtest';
import bridge from 'common/bridge';
import Utils from 'common/Utils';
import log from 'common/Logger';
import {getCreatedDateEpoch, getLastLoginDateEpoch, getUserSettings, getUserEmail} from "../common/UserService";
import {updateHubspotClient} from "../common/api";

let extra_attribs = {};
let loaded = false;


export function loadHubspot() {
    const user = _.result(bridge.session, 'user', {}) || {};
    const userRole = _.result(bridge.user, 'role', null);
    window.hubspotSettings = {
        email: user.email,
        attributes: {
            'user_id': user.id,
            'role': userRole,
            'firstname': _.capitalize(user.firstName),
            'lastname': _.capitalize(user.lastName),
            'username': user.username,
            'fullname': Utils.getFullname(user),
            'last_login_date': getLastLoginDateEpoch(),
            'create_date': getCreatedDateEpoch(),
            'ab_test': abtest.abTestId,
            'ab_test_var': abtest.uid,
            ...extra_attribs,
        }
    };
    const userSettings = getUserSettings();
    if (!_.isEmpty(userSettings)) {
        if (!_.isEmpty(userSettings.subscription)) {
            window.hubspotSettings.attributes.sub_active = _.result(userSettings, 'subscription.active', false);
            window.hubspotSettings.attributes.sub_id = _.result(userSettings, 'subscription.sub_id', '');
            window.hubspotSettings.attributes.sub_created_at = _.result(userSettings, 'subscription.start_date', '');
            window.hubspotSettings.attributes.sub_product_id = _.result(userSettings, 'subscription.product_id', '');
            window.hubspotSettings.attributes.sub_price_id = _.result(userSettings, 'subscription.price_id', '');
            window.hubspotSettings.attributes.sub_status = _.result(userSettings, 'subscription.status', '');
        }
        if (userSettings.school_name) {
            window.hubspotSettings.attributes.school_name = userSettings.school_name;
        }
        if (userSettings.job_title) {
            window.hubspotSettings.attributes.job_title = userSettings.job_title;
        }
        if (userSettings.ref) {
            window.hubspotSettings.attributes.ref = userSettings.ref;
        }
    }
    updateHubspot(window.hubspotSettings.attributes);
    loaded = true;
}

export function updateHubspot(settings = {}) {
    try {
        extra_attribs = _.assign(extra_attribs, settings);
        if (window.hubspotSettings) {
            try {
                log.debug('updating hubspot', settings);
                window.hubspotSettings.attributes = extra_attribs;
                let email = window.hubspotSettings.email;
                if (!email || email === 'undefined' || email === 'null' || email === '') {
                    email = getUserEmail();
                    if (!email || email === 'undefined' || email === 'null' || email === '') {
                        log.always('No email found for HubSpot settings');
                        return;
                    }
                    window.hubspotSettings.email = email
                }
                updateHubspotClient(window.hubspotSettings.email, extra_attribs);
            } catch (error) {
                log.error('Error updating HubSpot settings:', error);
            }
        } else {
            log.warn('hubspotSettings not initialized');
        }
    } catch (error) {
        log.error('Error in updateHubspot:', error);
    }
}

export function loadHubspotForLeads() {
    if (loaded) return;
    updateHubspot(window.hubspotSettings.attributes)
}